// Single source of truth for article metadata.
//
// Both Articles.vue (the listing) and the per-article view components
// (frontend/src/views/articles/*.vue) read from here so the publication
// date can't drift between listing and detail views (an earlier bug).

export const articles = [
  {
    id: 1,
    contentId: 'optimal-floorplan',
    path: '/artikel/optimal-floorplan',
    image: '/images/articles/pexels-marco-ottaviano-2068087-7190383.jpg',
    publicationDate: '2024-03-20',
    titles: {
      de: 'Optimale Raumaufteilung für kleine Wohnungen',
      en: 'Optimal Room Layout for Small Apartments'
    },
    descriptions: {
      de: 'Erfahren Sie, wie Sie auch auf kleiner Fläche optimal leben können und welche Gestaltungsprinzipien dabei helfen.',
      en: 'Learn how to live optimally in small spaces and which design principles can help.'
    }
  },
  {
    id: 2,
    contentId: 'sustainable-floorplan',
    path: '/artikel/nachhaltiger-grundriss',
    image: '/images/articles/pexels-laup-2976176.jpg',
    publicationDate: '2024-03-22',
    titles: {
      de: 'Nachhaltigkeit im Grundriss: Zukunftsorientiert Planen',
      en: 'Sustainability in Floor Plans: Future-Oriented Planning'
    },
    descriptions: {
      de: 'Wie Sie durch clevere Grundrissplanung Energie sparen und nachhaltig wohnen können.',
      en: 'How smart floor plan design can help you save energy and live sustainably.'
    }
  }
];

export function getArticleByContentId(contentId) {
  return articles.find((a) => a.contentId === contentId);
}
